import { ReportingActionTypes } from '../actions/reportingActions';
import { map, mapValues, toNumber } from 'lodash';
import { DateTime } from 'luxon';

import { ALL_APPS } from '../../utils/constants';

const initialState = {
  loading: true,
  data: {
    analytics: {},
    revenues: {}
  },
  filters: {
    app: ALL_APPS
  },
  ui: {
    analytics: {},
    revenues: {}
  }
};

/*function convertToReadableNumber(n) {
  n = toNumber(n);
  return n === parseInt(n, 10)
    ? n
    : n > 1 || n < -1
      ? n.toFixed(2)
      : n.toFixed(20).match(/^-?\d*\.?0*\d{0,2}/)[0];
}*/

function getReportData(appReports) {
  const format = 'yyyy-MM-dd'; //type === 'analytics' ? 'yyyyMMdd' : 'yyyy-MM-dd';
  return mapValues(appReports, reports =>
    mapValues(reports, reportData => {
      return !Array.isArray(reportData)
        ? toNumber(reportData).toLocaleString('en-US')
        : map(reportData, point => {
            return {
              date: DateTime.fromFormat(point.date, format).toFormat('dd MMM'),
              dateValue: DateTime.fromFormat(point.date, format).toMillis(),
              value: toNumber(point.value) || 0
            };
          }).sort((a, b) => {
            return a.dateValue - b.dateValue;
          });
    })
  );
}

function filterReports(state, appName) {
  appName = appName || state.filters.app;
  return {
    ...state,
    loading: false,
    filters: {
      app: appName
    },
    ui: {
      analytics: { ...state.data.analytics[appName] },
      revenues: { ...state.data.revenues[appName] }
    }
  };
}

function onFetchReportsSuccess(
  state,
  { data: { revenues, analytics, appName } }
) {
  //parsing values to numbers for chart
  state.data = mapValues({ revenues, analytics }, getReportData);
  return filterReports(state, appName);
}

export default function(state = initialState, action) {
  switch (action.type) {
    case ReportingActionTypes.REPORTING_APP_FILTER:
      return filterReports(state, action.payload.appName);
    case ReportingActionTypes.FETCH_REPORTS_REQUESTED:
      return { ...state, loading: true };
    case ReportingActionTypes.FETCH_REPORTS_SUCCEEDED:
      return onFetchReportsSuccess(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reportingReducer.js